/**
 * Created by Mark on 28/11/2016.
 */


import React from "react";

export default class ProgressBarComponent extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.state = {
            max: this.props.max || 100,
            min: this.props.min || 0,
            now: this.props.now || 0
        }
    }


    componentWillReceiveProps(props){

        this.setState({
            now:props.now
        })
    }

    render(){

        const style = {
            width: this.state.now + '%'
        };

        return (
            <div className="progress">
                <div className="progress-bar palette-Branding secondary bg" role="progressbar" style={style} >
                    <span className="sr-only">60% Complete</span>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/wizard/progress-component.js